<!--教师年龄-->
<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "pieEcharts",
    props: {
        id:{
            type: String,
            default:"tea_age_pie_echarts"
        },
        age1Count:{
            type: Number,
            default: 0
        },
        age2Count:{
            type: Number,
            default: 0
        },
        age3Count:{
            type: Number,
            default: 0
        },
        age4Count:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: true,
                    bottom:0,
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            fill: "#333333",
                            lineHeight:30,
                            fontSize: 20,
                            fontWeight: 'bold'
                        },
                    },
                ],
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['55%', '75%'],
                        avoidLabelOverlap: false,
                        color: [
                            '#91cc75',
                            '#fac858',
                            '#ee6666',
                            '#3ba272',
                            '#fc8452',
                            '#9a60b4',
                            '#ea7ccc',
                        ],
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 10,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.age1Count,'name':"30岁以下"});
            list.push({'value':this.age2Count,'name':"30-50岁"});
            list.push({'value':this.age3Count,'name':"50岁以上"});
            list.push({'value':this.age4Count,'name':"未知"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.title.text = "教师年龄结构"
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    flex-direction: column;
    padding: 10px 10px 10px 0;
    margin-left: 10px;
    box-shadow: var(--el-box-shadow-light);
    div {
        width: 100%!important;
        height: 300px;
    }
}
</style>